interface EnderecoData {
  endereco?: string | null;
  logradouro?: string | null;
  numero?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  estado?: string | null;
  uf?: string | null;
  cep?: string | null;
}

export function formatEndereco(
  endereco: EnderecoData,
  formato: 'padrao' | 'certificado' = 'padrao',
): string {
  const estado = endereco.estado || endereco.uf;

  if (formato === 'certificado') {
    const linha = [endereco.logradouro, endereco.numero, endereco.complemento]
      .filter((p): p is string => Boolean(p))
      .join(', ');
    const cidadeEstado = [
      endereco.bairro,
      endereco.cidade && estado ? `${endereco.cidade}/${estado}` : endereco.cidade || estado,
    ]
      .filter((p): p is string => Boolean(p))
      .join(' — ');
    const cep = endereco.cep ? `CEP ${endereco.cep}` : '';
    return [linha, cidadeEstado, cep].filter(Boolean).join(', ');
  }

  const logradouro = endereco.endereco || endereco.logradouro;
  const parts = [logradouro, endereco.cidade, estado].filter(Boolean);
  const enderecoStr = parts.join(' - ');
  return endereco.cep ? `${enderecoStr} - CEP ${endereco.cep}` : enderecoStr;
}
